import React, { Component } from 'react';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';
import AllNewsContainer from "../news/containers/allnewscontainer.component";
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import Spinner from "../../../SHARED/components/spinner/spinner.component";
import {getEventDetails} from "../../../SHARED/actions/festival.actions";
import Moment from "react-moment";
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';


class EventDetails extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
        const eventId = this.props.match.params.id;
        this.props.getEventDetails(eventId);
    }

    componentDidMount() {
        pageViewEvent(this.props.eventDetails.event_title,window.location.href)
     }

    render() {
        return (
            <div className="container-fluid news-details">     
                {this.props.loading !== 0 ? <Spinner /> : ''} 
                <Helmet>
                    <title>{this.props.eventDetails.event_title}</title>
                    <meta name="description" content={this.props.eventDetails.event_description ? this.props.eventDetails.event_description.substring(0,this.props.eventDetails.event_description.indexOf('</p>')).replace( /(<([^>]+)>)/ig, '') : `Nu există descriere pentru ${this.props.eventDetails.event_title}`}/>
                    <link rel="canonical" href={window.location.href}/>    
                </Helmet>   
                <div className="row">
                    {<div className="col-lg-9">
                        <div className="w-100 p-3">
                            <div className="news-details-img">
                                <img src={Parser(API_URL + this.props.eventDetails.event_image)} alt={'Event'} />       
                            </div> 
                            <div className="col-lg-12 p-2 clearfix text-details">
                                <span className="grey-text db">Tipul evenimentului: {this.props.eventDetails.event_type}</span>
                                <span className="grey-text db"></span>
                                <span className="grey-text db">Data: {" "}
                                    <Moment format="DD MMMM YYYY" locale="ro" unix>
                                        {this.props.eventDetails.event_date}
                                    </Moment></span>
                                <span className="grey-text db">Ora: {this.props.eventDetails.event_time}</span>
                                <span className="grey-text db">Locatie:  
                                    {this.props.eventDetails.event_location_name + ", " + this.props.eventDetails.event_location_locality}
                                </span>
                            </div>  
                            <div className="col-lg-12 clearfix p-2">
                                <h3 className="text-white">{this.props.eventDetails.event_title}</h3>
                            </div>
                            <div className="news-details-description">
                                { this.props.eventDetails.event_description ? Parser(this.props.eventDetails.event_description) : ''}
                            </div>
                        </div>
                    </div>}
                    <div className="col-lg-3 w-10 p-3">
                        <AllNewsContainer />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    eventDetails: state.festival.eventDetails
});

export default connect(mapStateToProps,{getEventDetails})(EventDetails);


// WEBPACK FOOTER //
// ./src/FO/components/eventdetails/eventdetails.component.js